(ns frontend.ui.component.lp-portal.report.body.voima.fund.pdf-pages.data-dump
  (:require
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.report.component.horizontal-table.pdf-view :as horizontal-table-pdf]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.report.body.voima.fund.pdf-pages.fund-overview :refer [empty-table-data?]]))

(defn data-dump-table
  [data]
  (let [remove-page? (empty-table-data? data :data-dump)]
    (when-not remove-page?
      (page/page
       (page/page-title-with-line {:fund-name  (:fund-name data)
                                   :page-title "Additional data"
                                   :toc-item   true})
       (horizontal-table-pdf/table (->> data
                                        :data-dump)
                                   {:font-size 4.5})))))


(defn data-dump-pages
  [data]
  (data-dump-table data))
